package de.katoonerie.stylesheet

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.value
import org.jetbrains.compose.web.css.variable

object AppCssVariables {
    val backgroundColor by variable<CSSColorValue>()
    val accentColor by variable<CSSColorValue>()
}

object AppStylesheet : StyleSheet() {
    val gradient by style {
        property("background-image", "linear-gradient(${AppCssVariables.accentColor.value()}, ${AppCssVariables.backgroundColor.value()})")
    }
}
